__turbopack_context__.v({
  "content": "styles-module___xUaDW__content",
  "ctaButton": "styles-module___xUaDW__ctaButton",
  "title": "styles-module___xUaDW__title",
});
